import React, { useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import axios from "../axiosInstance";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import { errorMessage } from '../hooks/UserLogs';

function ChangePwdUserAgency() {
    const [showDd, setshowDd] = useState(false);
    const [oldPwd, setoldPwd] = useState("");
    const [newPwd, setNewPwd] = useState("");
    const [confPwd, setConfPwd] = useState("");
    const [msg, setMsg] = useState(false);
    const [showError, setShowErro] = useState(false);
    const [showSc, setShowSc] = useState(false);
    const [errorPwd,setErrorPwd]= useState("");
    const bUrl=process.env.REACT_APP_B_URL;
    const navigate = useNavigate();

    const axiosInstance = axios.create({
                  withCredentials: true,
                })

    const validatePwd=(e)=>{
      e.preventDefault();
      const pwd_pattern=/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,}$/;
      let isvalid=true;
      if(newPwd===""){
        setErrorPwd("Field is required!")
        isvalid=false;
        
      }else if(!pwd_pattern.test(newPwd)){
        setErrorPwd("Lettre(s) miniscule(s)-Lettre(s) Majuscule(s)-chiffre(s):8 charactaires minimum")
        isvalid=false;
      }
      
      if(isvalid){
        changePwd();
      }
      
    }
    useEffect(()=>{
      if (sessionStorage.getItem("idAgency") === '' || sessionStorage.getItem("idAgency") === null) {
        //console.log("----------GO GO GO ------------")
        navigate('/agency-user-login');
      }
    })
    const handleCloseError=()=>{
      setShowErro(false);
    }
    
    const header=
    {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    }
          //'Authorization':sessionStorage.getItem('access_token')
    const handleCloseSc=()=>{
      setShowSc(false);
    }
    const changePwd=()=>{
        
        if(newPwd==confPwd){
  
          axiosInstance.post(bUrl+"/agency-user/change-password", {
            oldPassword: oldPwd,
            newPassword: newPwd,
            id: sessionStorage.getItem("idUser")
            },{header:header})
            .then(function (response) {
              //postRequest();
              
              console.log(response);
              if(!response?.data['isError']) {
                setMsg("Password changed Successfuly")
                navigate('/agency-user-login');
              }else{
                if (response?.data?.isError) {
                  const msg = errorMessage(response?.data?.code)
                  setMsg(msg);
                  setShowErro(true);
                }
              }
              
              //setShowSc(true);
              //return response.data;
            })
            .catch(function (error) {
              
              setShowErro(true);
              
            });
        }else{
          setMsg("Password not match");
          //================================
          //setShowErro(true);
        }
       
    
      }
  return<>
    <div className="">
      {/* <Sidebar/> */}
      <section className="home ">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12 ">
                          <Topbar/>
        <div className='table-content  p-3 col-md-6 m-auto mt-5'>
        <div className='d-flex justify-content-center '>
           
         <form className='col-md-6 text ' >
            <div className="form-group mb-2">
              <label htmlFor="oldPd">Old Password</label>
              <input type="password" id='oldPd' name="Hold Password" className='form-control' onChange={(e)=>setoldPwd(e.target.value)}  minLength={8}/>
            </div>
            <div className="form-group mb-2">
              <label htmlFor="NewPwd">New Password</label>
              <input id="NewPwd" type="password"  name="New Password" className='form-control' onChange={(e)=>setNewPwd(e.target.value)}   minLength={8}/>
              {errorPwd!=""&& <p style={{color:'red'}}>{errorPwd}</p>}
            </div>
            <div className="form-group mb-2">
            <label htmlFor="cpwd">Confirm Password</label>
              <input id="cpwd" type="password"  name="Confirm" className='form-control' onChange={(e)=>setConfPwd(e.target.value)}   minLength={8}/>
              {msg!=""&& <p style={{color:'red'}}>{msg}</p>}
            </div>
            <div className='form-group mb-2 d-flex flex-row-reverse'>
                <button className='btn btn-primary ' onClick={(e)=>validatePwd(e)}>Update</button>
            </div>
            
          </form>
         
    </div>
    </div>
    </div>
    </div>
    </section>
    </div>
    
    
    <Modal show={showError} onHide={handleCloseError} className="modal-sm">
        <Modal.Header closeButton>
          <Modal.Title>Erreure</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{textAlign:'center'}}>{msg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Fermer
          </Button> 
        </Modal.Footer>
        </Modal>
       
   
  </>
}
export default ChangePwdUserAgency;